export default __webpack_public_path__ + "static/media/avatar_7.8ccfacfa.svg";